import OriginalDropdown from './Dropdown.svelte';
import OriginalItems from './Items.svelte';
import Item from './Item.svelte';
import Divider from './Divider.svelte';
import Icon from '../icon/Icon.svelte';
const Dropdown = OriginalDropdown;
Dropdown.Items = OriginalItems;
Dropdown.Items.Item = Item;
Dropdown.Items.Divider = Divider;
Dropdown.Items.Item.Icon = Icon;
export default Dropdown;
